import { Permission, PermissionValue, isPermissionVisible } from './permissionHelpers'

export const getActiveRolePermissions = (permissions: Permission[], values: PermissionValue[]) => {
  const byId = new Map(values.map(item => [item.id, item.value]))
  return values.filter(item => {
    const permission = permissions.find(candidate => candidate.id === item.id)
    return (
      permission &&
      item.value !== null &&
      item.value !== false &&
      item.value !== '' &&
      isPermissionVisible(permission, permissions, id => byId.get(id) ?? null)
    )
  })
}

export const roleSettingsKey = (values: Record<string, any>) =>
  JSON.stringify({
    name: values.name ?? '',
    is_active: Boolean(values.is_active),
    start_page: values.start_page ?? '',
    priority: values.priority ?? null,
    permissions: [...(values.permissions || [])].sort((a, b) => a.id - b.id),
    notifications: (values.notifications || [])
      .map(({ type, enabled }) => ({ type, enabled: Boolean(enabled) }))
      .sort((a, b) => a.type.localeCompare(b.type)),
  })
